<div class="wrapper">
    <app-navigation></app-navigation>

    <div class="content-wrapper">
        <app-content-transition></app-content-transition>
        <app-header location="Enterprise Wallet Balance"></app-header>
        <app-enterprise-links [id]="id"></app-enterprise-links>

        <app-wallet-balance [supplierId]="supplierId"></app-wallet-balance>
    </div>
</div>
